var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ErrorPage',[_vm._v("\n  Our experts can still help you "),_c('strong',[_vm._v("choose the right business broadband and phone line products")]),_vm._v(" on a quick call. Please call us on the number below.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }